import React from 'react';
import { useTranslation } from 'react-i18next';
import faqImg from '../assets/webp/faq.webp';
import faqData from '../assets/faq.json';

const TEXT_DARK = '#1A1A2E';
const TEXT_SECONDARY = '#6B7280';

interface FAQItem {
  id: number;
  question: string;
  answer: string;
}

const FAQPage: React.FC = () => {
  const { t } = useTranslation();
  const items: FAQItem[] = (faqData as { faq: FAQItem[] }).faq;

  return (
    <div className="flex flex-col flex-grow overflow-hidden bg-gray-50" dir="rtl">
      <h3 className="m-0 text-lg font-bold text-center flex-shrink-0" style={{ color: TEXT_DARK }}>
        {t('faq_page_title', 'שאלות נפוצות FAQ')}
      </h3>

      <div className="px-4 flex-shrink-0">
        <div className="relative w-full rounded-t-2xl" style={{ height: 140 }}>
          <img src={faqImg} alt="" className="w-full h-full object-cover" />
        </div>
      </div>

      <div className="mx-['16px'] my-0 p-['5px'] border border-gray-300 flex-1 overflow-y-auto flex flex-col gap-2 ">
        {items.map((item) => (
          <div key={item.id} className="bg-white rounded-xl border border-gray-200 shadow-sm p-3">
            <h3
              className="overflow-hidden text-sm font-bold text-right mb-1"
              style={{ color: TEXT_DARK }}
            >
              {item.question}
            </h3>
            <hr className="border-gray-100 mb-1" />
            <p
              className="text-sm leading-relaxed"
              style={{ color: TEXT_SECONDARY, textAlign: 'right' }}
            >
              {item.answer}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQPage;
